<template>
  <div class="tree-menu">
    <div class="label-wrapper" @click="toggleChildren">
      <div id="label" :style="indent" :class="labelClasses">
        <div v-if="nodes" style="margin-right: 5px;">
          <img v-if="showChildren" src="../../assets/treetable/button-open.png" />
          <img v-else src="../../assets/treetable/button-closed.png" />
          {{ label }}
        </div>
        <div v-else style="padding-left: 15px;">
          {{ label }}
        </div>
      
      </div>
      <div class="firstDataColumn">
          <span v-if="nodeModule">{{ nodeModule }}</span>
      </div>
      <div class="secondDataColumn">
          <span v-if="nodeFunction">{{ nodeFunction }}</span>
          <span> ({{nodeTimeType}})</span>
      </div>
      <div class="secondDataColumn">
          <span v-if="nodeID">{{ nodeID }}</span>
      </div>
      <!-- Case that we show the node STATISTICS -->
      <div v-if="nodeShowStatistics">
        <div v-for="(item, index) in nodeData" :key="index" class="otherDataColumn">
          <div v-if="index == 0" class="flexcontainer_column">
            <div v-for="entry in Object.entries(item)" :key="'A'+ entry">
              <b>mean: </b> {{entry[1]}}
            </div>
          </div>
          <div v-else class="flexcontainer_column" style="text-align: center;">
            <div v-for="entry in Object.entries(item)" :key="'B'+ entry">
              {{entry[1]}}
            </div>
          </div>
        </div>
        <!-- Add one more column in case we show statistics to show the growth -->
        <div v-if="nodeTimeType == 'individual'" class="otherDataColumn">
          <div class="flexcontainer_column">
            <b>Avg. growthrate:</b>
            {{nodeAvgGrothRate}}
          </div>
        </div>
      </div>

      <!-- Case that we show the node PARAMETER settings -->
      <!-- If we have individually defined distributions, then we need to loop through all periods -->
      <div v-if="nodeTimeType == 'individual'">
        <div v-for="(parameterArray, period) in nodeParameters" :key="period" class="otherDataColumn">

          <!-- Create a second loop where we loop over the individual parameters -->
          <div v-for="(parameterObject, index) in parameterArray" :key="index">

            <label>{{parameterObject.key}}</label>
            <input type="number" @change="udpateParameter(nodeID, period, parameterObject.key, nodeParameters[period][index].value, nodeTimeType)" v-model.number="nodeParameters[period][index].value" style="width:80%"/>

          </div>

        </div>
      </div>
      <!-- If we do not have indidually defined distributions (e.g. growthrate or constant) -->
      <div v-else>

        <div class="otherDataColumn">
         <!-- Loop over parameters for period 0 only -->
          <div v-for="(parameterObject, index) in nodeParameters[0]" :key="index">

            <!-- Have disabled inputs of the node is not in the currently active module -->
            <div v-if="nodeNotInCurrentlyActiveModule">
              <label>{{parameterObject.key}}</label>
              <input type="number" @change="udpateParameter(nodeID, 0, parameterObject.key, nodeParameters[0][index].value, nodeTimeType)" v-model.number="nodeParameters[0][index].value" style="width:80%; background-color: #EDEDED;" disabled />
            </div>

            <!-- Have active inputs of the node IS in the currently active module -->
            <div v-else>
              <label>{{parameterObject.key}}</label>
              <input type="number" @change="udpateParameter(nodeID, 0, parameterObject.key, nodeParameters[0][index].value, nodeTimeType)" v-model.number="nodeParameters[0][index].value" style="width:80%"/>
            </div>

          </div>
        </div>

      </div>

    </div>

    <div v-if="showChildren">
      <TreeTable
        v-for="node in nodes"
        :key="node.nodeUUID"
        :nodes="node.nodes" 
        :label="node.label"
        :nodeData="node.nodeData"
        :nodeModule="node.nodeModule"
        :nodeParameters="node.nodeParameters"
        :nodeTimeType="node.nodeTimeType"
        :nodeNotInCurrentlyActiveModule="node.nodeNotInCurrentlyActiveModule"
        :nodeAvgGrothRate="node.nodeAvgGrothRate"
        :nodeShowStatistics="node.nodeShowStatistics"
        :nodeFunction="node.nodeFunction"
        :nodeID="node.nodeID"
        :nodeUUID="node.nodeUUID"
        :depth="depth + 1"   
      >
      </TreeTable>
    </div>
  </div>
</template>


<script>
  import Vue from 'vue';
  import TreeTable from './TreeTable.vue';
  Vue.component('TreeTable', TreeTable);

  export default { 
    name: 'TreeTable',
    props: [ 'label', 'nodes', 'depth', 'nodeData', 'nodeFunction', 'nodeID', 'nodeModule', 'nodeParameters', 'nodeTimeType', 'nodeNotInCurrentlyActiveModule', 'nodeShowStatistics', 'nodeAvgGrothRate'],
    components: { TreeTable },
    data() {
      return {
        showChildren: false,
        labelClasses: undefined,
        iconClasses: undefined,
      }
    },
    mounted() {

    },
    computed: {
      indent() {
        // return { transform: `translate(${this.depth * 30}px)` }
        return { 
          padding: `0px 0px 0px ${this.depth * 20}px`,
          width: `${300 - this.depth * 20}px`,
          'max-width':`${300 - this.depth * 20}px`,
          'text-overflow': 'ellipsis',

          /* Required for text-overflow to do anything */
          'white-space': 'nowrap',
          overflow: 'hidden'
        }
      }
    },
    methods: {
      toggleChildren() {
        this.showChildren = !this.showChildren;
      },
      udpateParameter(nodeID, period, parameterKey, newValue, nodeTimeType) {

        // console.log('nodeID', nodeID);
        // console.log('period', period);
        // console.log('parameterKey', parameterKey);
        // console.log('newValue', newValue);
        // console.log('nodeTimeType', nodeTimeType);

        // We let the menue listen to this event and update the node accordingly
        // Chose menue since all components are available there already to handle this
        Vue.prototype.$eventHub.$emit("updateNodeParameter", {
          'nodeID': nodeID,
          'period': period,
          'parameterKey': parameterKey,
          'newValue': newValue,
          'nodeTimeType': nodeTimeType
        });

      }
    }
  }
</script>


<style scoped>

  .tree-menu {
    /* line-height: 1em; */
    /* background-color: red; */
    font-size: small;
  }

  .tree-menu .label-wrapper {
      padding-bottom: 10px;
      margin-bottom: 10px;
      border-bottom: 1px solid #ccc;
      display: flex;
  }

  .tree-menu .label-wrapper .has-children {
    cursor: pointer;
  }

  .firstDataColumn {
    /*margin-left: 280px;*/
    width: 150px;
    /* height: 1em; */
    float: left;
    /*background-color: green;*/
  }

  .secondDataColumn {
    width: 100px;
  }

  .otherDataColumn {
    width: 100px;
    float: left;
    /* height: 1em; */
  }

  #label {
    float: left;
  }

  .label{
    
  }

  .flexcontainer_column {
   display: flex;
   flex-direction: column;
}

  /* For the labels of input fields in the tab view */
  .block label { 
    display: inline-block; 
    width: 140px; 
    text-align: right; 
  }


</style>
